import React from 'react';
import PropTypes from 'prop-types';
import { fromJS } from 'immutable';
import { get } from 'lodash-es';
import { SummaryBlock } from '@coog/components-library';

import {
  transformToQuestionnaireSummary,
  transformToLoansSummary,
  transformToQuotationSummary,
  transformToExtraDataSummary,
  transformToGeneralDataSummary,
  transformToOfferSummary,
  transformToSubscriptionSummary,
  transformToDocumentsSummary,
} from '../EditSalesRoute.transform';

/** *
 * Summary Block
 */
const Summary = ({
  code,
  blockQuestionnaire,
  blockLoans,
  blockQuotation,
  blockExtraData,
  blockGeneralData,
  blockOffers,
  blockSubscription,
  blockDocuments,
  i18n,
  strings,
}) => {
  let list = [];
  let groups = [];
  const locale = get(i18n, 'lang', 'fr');

  switch (code) {
    case 'questionnaires':
      list = transformToQuestionnaireSummary(blockQuestionnaire, locale, strings);
      break;
    case 'loans':
      groups = transformToLoansSummary(blockLoans, locale, strings);
      break;
    case 'quotations':
      groups = transformToQuotationSummary(blockQuotation, locale, strings);
      break;
    case 'extra_data':
      list = transformToExtraDataSummary(blockExtraData, locale, strings);
      break;
    case 'generalData':
      list = transformToGeneralDataSummary(blockGeneralData, locale, strings);
      break;
    case 'offers':
      list = transformToOfferSummary(blockOffers, locale, strings);
      break;
    case 'subscription':
      groups = transformToSubscriptionSummary(blockSubscription, locale, strings);
      break;
    case 'documents':
      list = transformToDocumentsSummary(blockDocuments, locale, strings);
      break;
    default:
      list = [];
  }

  return groups.length > 0 ? <SummaryBlock groups={groups} /> : <SummaryBlock list={list} />;
};

Summary.propTypes = {
  code: PropTypes.string.isRequired,
  blockQuestionnaire: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  blockLoans: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  blockQuotation: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  blockExtraData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  blockGeneralData: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  blockOffers: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  blockSubscription: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  Documents: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  i18n: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  strings: PropTypes.objectOf(PropTypes.string),
};

Summary.defaultProps = {
  blockQuestionnaire: {},
  blockLoans: {},
  blockQuotation: {},
  blockExtraData: {},
  blockGeneralData: {},
  blockOffers: [],
  blockSubscription: {},
  Documents: {},
  i18n: fromJS({}),
  strings: {},
};

export default Summary;
